import { Button } from "primereact/button";
import { Divider } from "primereact/divider";
import { InputText } from "primereact/inputtext";
import { RadioButton } from "primereact/radiobutton";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  updateCustomerSetup,
  getCustomers,
} from "../../store/AsyncMethods/CustomerMethod";
import { updateVendorSetup } from "../../store/AsyncMethods/VendorMethod";
export default function CustomerSetup({ vendor }) {
  const dispatch = useDispatch();

  // Helper function to convert between radio value and numeric value
  const getTransactionTypeValue = (radioValue) => {
    return radioValue === "credit" ? 0 : 1;
  };

  // Helper function to convert from numeric value to radio value
  const getRadioValue = (numericValue) => {
    return numericValue === 0 ? "credit" : "debit";
  };

  const formik = useFormik({
    initialValues: {
      id: "",
      vendor: "",
      name: "",
      paymentType: "credit", // Default radio value
    },
    validationSchema: Yup.object({
      paymentType: Yup.string().required("Transaction type is required"),
    }),
    onSubmit: async (values) => {
      // Convert the radio value to numeric value before submission
      const submissionValues = {
        ...values,
        paymentType: getTransactionTypeValue(values.paymentType),
      };
      console.log("Form submitted with values:", submissionValues);
      dispatch(updateVendorSetup(submissionValues, vendor.id)).then(
        (success) => {
          if (success) {
            console.log("vendor setup updated successfully!");
          }
        }
      );
    },
  });

  useEffect(() => {
    formik.setValues({
      vendor: vendor.id,
      name: vendor.name,
      paymentType: vendor.paymentType, // Default to credit (which will be 0 when submitted)
    });
  }, []);

  return (
    <div className="card shadow-md rounded-lg p-4 mt-1">
      <Divider>
        <span className="text-2xl font-bold p-font-style text-center text-primary mx-1">
          {"vendor Setup"}
        </span>
      </Divider>

      <form onSubmit={formik.handleSubmit}>
        <div className="px-4 gap-4 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-2">
          <div className="">
            <div className="flex flex-col gap-2">
              <label htmlFor="siteId" className="">
                {"vendor Name"}
              </label>
              <span className="w-full">
                <InputText
                  disabled
                  id="name"
                  name="name"
                  className="w-full text-lg p-primary-input"
                  value={formik.values?.name}
                  onChange={formik.handleChange}
                />
              </span>
            </div>
          </div>

          <div className="">
            <div className="flex flex-col gap-2">
              <label className="">{"Transaction Type"}</label>
              <div className="flex gap-4">
                <div className="flex align-items-center">
                  <RadioButton
                    inputId="credit"
                    name="paymentType"
                    value="credit"
                    checked={formik.values.paymentType === "credit"}
                    onChange={formik.handleChange}
                  />
                  <label htmlFor="credit" className="ml-2">
                    Credit (No Udhar)
                  </label>
                </div>
                <div className="flex align-items-center">
                  <RadioButton
                    inputId="debit"
                    name="paymentType"
                    value="debit"
                    checked={formik.values.paymentType === "debit"}
                    onChange={formik.handleChange}
                  />
                  <label htmlFor="debit" className="ml-2">
                    Debit
                  </label>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-16">
            <div className="flex justify-end gap-4">
              <Button
                label={"cancel"}
                icon="pi pi-times"
                className="p-red-btn"
                type="button"
                onClick={() => {
                  formik.resetForm();
                }}
              />
              <Button
                label={"submit"}
                type="submit"
                icon="pi pi-check"
                className="p-secondary-btn"
              />
            </div>
          </div>
        </div>
      </form>
    </div>
  );
}
